import React from 'react';
import { translate } from 'react-i18next';
import { Form } from 'common/components';

const ProvidersActionsToggle = ({ provider, t, handleClick }) => {
  return (
    <Form.Button
      onClick={(e) => {
        e.preventDefault();
        handleClick(provider.id);
      }}
      text={t(provider.active ? 'actions.deactivate' : 'actions.activate')}
      color={provider.active ? 'outline-warning' : 'outline-info'}
      extraClassName={'btn-sm'}
      isLoading={provider.isLoading}
    />
  );
};

export default translate()(ProvidersActionsToggle);



// WEBPACK FOOTER //
// src/modules/secured/modules/providers/components/list/actions/ProvidersActionsToggle.js